// RB2 Core Connect
import { RemixBrowser } from "@remix-run/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

import { initSentryClient } from "~/sentry.client";
import { installGlobalFeatureToggle } from "~/lib/featureToggle";

initSentryClient();
installGlobalFeatureToggle();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});
